export const FEEDBACK_FORM_URL = "https://airtable.com/app4NdLAtPFiNLSm3/pag10n62yzp4GnaHf/form";
